import { BaseError } from './BaseError.js';
/**
 * Error thrown when validation fails.
 * Used for input validation, schema validation, business rule violations, etc.
 */
export class ValidationError extends BaseError {
    field;
    details;
    name;
    constructor(message, field, cause, details, name = 'ValidationError') {
        super(message, cause);
        this.field = field;
        this.details = details;
        this.name = name;
    }
}
//# sourceMappingURL=ValidationError.js.map